import { GoBackButton } from "./GoBackButton";

export default GoBackButton;
